import { DASHBOARD_TAB_PERMISSION } from "../../../config/userPermissionConstants";
export const GOING_WELL_LABEL = "going well";
export const IMPROVEMENT_LABEL = "improve";
export const LOW_COUNT_COMMENT = 'lowCountComment'
export const HIGH_COUNT_COMMENT = 'highCountComment'
export const ELEMENTS = {
  GOING_WELL: "goingWell",
  IMPROVEMENT: "whatCanBeImproved",
  LESS_COUNT_COMMENT_QUESTION: 'LessCountCommentQuestion',
  HIGH_COUNT_COMMENT_QUESTION: 'highCountCommentQuestion',
  POSITIVE_OUTCOME_OUTLIER: "positiveMultipleDemographicSegmentOutlier",
  NEGATIVE_OUTCOME_OUTLIER: "negativeMultipleDemographicSegmentOutlier",
};
export const NAV_BAR_TABS = [
  { tab: "Storyboard", accessKey: DASHBOARD_TAB_PERMISSION.STORY },
  { tab: "Explore", accessKey: DASHBOARD_TAB_PERMISSION.EXPLORE },
  { tab: "Heatmap", accessKey: DASHBOARD_TAB_PERMISSION.HEATMAP },
  { tab: "Comments", accessKey: DASHBOARD_TAB_PERMISSION.COMMENTS },
  { tab: "Insights", accessKey: DASHBOARD_TAB_PERMISSION.INSIGHTS },
  { tab: "Manage", accessKey: DASHBOARD_TAB_PERMISSION.MANAGE },
];
export const STORYBOARD_TAB = "Storyboard"
export const COMMENT_ANALYSIS = "Comment Analysis";
export default {
  readMoreDriversString: (outcome) =>
    "Drivers explain which items are likely to have the biggest influence" +
    ` on employee ${outcome.toLowerCase()}. The items identified as the top drivers,` +
    " listed in rank order of importance, identify issues that are most" +
    ` likely having the biggest influence on ${outcome}. In effect, if the` +
    " organization improves the scores on these items, it will potentially" +
    ` improve the ${outcome} score.`,
  readMoreOutliersString:
    "Outliers are groups that show unusually high or low scores ",
  readMoreParticipationString:
    "Participation shows who responded to your survey",
};
export const FUNCTIONAL_VP = "functional vp"
export const SUB_STORY_CARD = {
  WHY_VERY_ENGAGED: "whyVeryEngaged",
  WHY_VERY_DISENGAGED: "whyVeryDisengaged",
  WHY_VERY_POSITIVE: "whyVeryPositive",
  WHY_VERY_NEGATIVE: "whyVeryNegative",
  WHAT_CAN_BE_IMPROVED_REASON: "whatCanBeImprovedSubCard",
  WHAT_IS_GOING_WELL_REASON: "goingWellSubCard"
}
export const ENGAGEMENT_SUB_CARD = {
  byScore: [{
    "topic": "Engagement",
    "scoreLevel": "favourable"
  }],
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments that explain why they feel highly engaged. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags."

  // prompt: "Give a short summary of the top three themes in these comments from employees to explain why they feel highly engaged."
}
export const DISENGAGEMENT_SUB_CARD = {
  byScore: [
    {
      "topic": "Engagement",
      "scoreLevel": "neutral"
    },
    {
      "topic": "Engagement",
      "scoreLevel": "unFavourable"
    }
  ],
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments that explain why they feel disengaged. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags.",
  // prompt: "Give a short summary of the top three themes in these comments from employees to explain why they feel disengaged."
}

export const POSITIVE_SUB_CARD = {
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments that explain why they have a positive sentiment. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags."
}

export const NEGATIVE_SUB_CARD = {
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments that explain why they have a negative sentiment. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags."
}

export const IMPROVEMENT_SUB_CARD = {
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags."
}

export const GOING_WELL_SUB_CARD = {
  prompt: "Provide a brief summary (maximum 100 words) of the top three themes from employee comments. Begin the response with a sentence wrapped in a <span> tag. Then, present the three themes as an unordered HTML list using <ul><li> tags. Do not include <strong>, <em>, <br>, or any other formatting tags."
}

export const FILTER_TYPE = {
  BY_SCORE: "byScore",
  FILTER: "filters",
  TOPICS_FILTER: "topicsFilter"
}